import { store } from '@/app/store'
import { setCurrency } from '@/features/settings/settingsSlice'
import {
  getCountryConfig,
  initCountryConfig,
  subscribeCountryConfig,
} from '@/services/countryConfigService'

function applyCurrencyFromSettings() {
  const { currency } = getCountryConfig()
  // Only apply when Settings provided a currency — never invent one from brand/flavor.
  if (currency) {
    store.dispatch(setCurrency(currency))
  }
}

// Fire-and-forget: reuse Settings fetch; never block startup.
void initCountryConfig().then(applyCurrencyFromSettings)
subscribeCountryConfig(applyCurrencyFromSettings)
